import { useState } from "react";
import { api, apiError } from "../../lib/api";
import { Reveal } from "./Reveal";
import { useT } from "../../lib/content";

export const Newsletter = () => {
  const [f, setF] = useState({ first_name: "", email: "", consent: false });
  const [msg, setMsg] = useState(null);
  const t = useT();
  const submit = async (e) => {
    e.preventDefault();
    if (!f.first_name.trim() || !/^\S+@\S+\.\S+$/.test(f.email) || !f.consent) { setMsg({ err: true, t: "Inscrivez votre prénom, un courriel valide et cochez la case." }); return; }
    try { await api.post("/newsletter", f); setMsg({ t: "Bienvenue ! Vous verrez les nouvelles toiles en premier." }); setF({ first_name: "", email: "", consent: false }); }
    catch (ex) { setMsg({ err: true, t: apiError(ex) }); }
  };
  const inp = "bg-white/10 border border-white/25 focus:border-[#E0C48C] outline-none px-4 py-3 text-[#F6F1E9] placeholder:text-slate-300 w-full";
  return (
    <section className="bg-[#3E6173] text-[#F6F1E9] py-20 sm:py-24" data-testid="newsletter-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-2 gap-10 items-center">
        <Reveal>
          <h2 className="f-display text-4xl sm:text-5xl font-light leading-tight">{t("news_title")}</h2>
          <p className="mt-4 text-slate-100 font-light">{t("news_text")}</p>
        </Reveal>
        <form onSubmit={submit} noValidate className="grid gap-4" data-testid="newsletter-form">
          <div className="grid sm:grid-cols-[1fr_1.3fr_auto] gap-3">
            <input className={inp} placeholder="Prénom" value={f.first_name} onChange={(e) => setF({ ...f, first_name: e.target.value })} data-testid="newsletter-input-firstname" aria-label="Prénom" />
            <input className={inp} type="email" placeholder="Courriel" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="newsletter-input-email" aria-label="Courriel" />
            <button className="btn-gold" type="submit" data-testid="newsletter-submit-button">S'inscrire</button>
          </div>
          <label className="flex items-center gap-3 text-sm text-slate-100 cursor-pointer">
            <input type="checkbox" checked={f.consent} onChange={(e) => setF({ ...f, consent: e.target.checked })} className="w-4 h-4 accent-[#E0C48C]" data-testid="newsletter-consent-checkbox" />
            Je veux m'inscrire à l'infolettre.
          </label>
          {msg && <p className={`text-sm ${msg.err ? "text-[#FFD2CC]" : "text-[#E0C48C]"}`} data-testid="newsletter-message">{msg.t}</p>}
        </form>
      </div>
    </section>
  );
};
